import { render, staticRenderFns } from "./dev-attr-by-page-mode.vue?vue&type=template&id=1855bd34"
import script from "./dev-attr-by-page-mode.vue?vue&type=script&lang=js"
export * from "./dev-attr-by-page-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports